import React from "react";
/* eslint-disable */
import {
  Box, TableHead, TableBody, TableCell, TableContainer, TableRow, Table
} from '@material-ui/core';
import moment from 'moment';

export default class ComponentToPrint extends React.Component {

  render() {
    const reportData = this.props.reportData;
    const data = this.props.searchData;
    const totalValues = this.props.totalRowValue;

    return (
      <div style={{ padding: '10px' }}>
        <h3><center><u>FCC InboundvTransactions Report - SKU wise</u></center></h3>
        <div>&nbsp;</div>

        <div>&nbsp;</div>
        <Box minWidth={1050}>
          <TableContainer style={{ marginLeft: '5px' }}>
            <Table aria-label="caption table">
              <TableHead>
                <TableRow>
                  <TableCell sx={{ fontWeight: "bold" }} align="left">GTN No</TableCell>
                  <TableCell sx={{ fontWeight: "bold" }} align="left">Lorry Number</TableCell>
                  <TableCell sx={{ fontWeight: "bold" }} align="left">Date</TableCell>
                  <TableCell sx={{ fontWeight: "bold" }} align="left">SKU Code</TableCell>
                  <TableCell sx={{ fontWeight: "bold" }} align="left">SKU Name</TableCell>
                  <TableCell sx={{ fontWeight: "bold" }} align="left">UOM</TableCell>
                  <TableCell sx={{ fontWeight: "bold" }} align="right">Quantity</TableCell>
                  <TableCell sx={{ fontWeight: "bold" }} align="right">Value (LKR)</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {reportData.map((row, index) => (
                  <TableRow key={index}>
                    <TableCell align="left">{row.gtnNumber}</TableCell>
                    <TableCell align="left">{row.lorryNumber}</TableCell>
                    <TableCell align="left">{moment(row.grnDate).format("YYYY/MM/DD")}</TableCell>
                    <TableCell align="left">{row.skuCode}</TableCell>
                    <TableCell align="left">{row.skuName}</TableCell>
                    <TableCell align="left">{row.uom==1 ? 'Unit' : row.uom==2 ?'Kilo':''}</TableCell>
                    <TableCell align="right">{row.quantity === 0 ? '-' : parseFloat(row.quantity).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                    <TableCell align="right">{row.totalValue === 0 ? '-' : parseFloat(row.totalValue).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                  </TableRow>
                ))}
                <TableRow>
                  <TableCell sx={{ fontWeight: "bold" }} colSpan={7}></TableCell>
                  <TableCell sx={{ fontWeight: "bold" }} align="right">{totalValues === 0 ? '-' : parseFloat(totalValues).toFixed(2)}</TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      </div>
    );
  }
}
